import { useAuth } from '@/context/Auth';
import { usePostMessageListener } from '@/hooks/usePostMessageListener';
import { getGenetecPostMessage } from '@/utils/helpers';
import { useCallback } from 'react';

const postMessageConnection = getGenetecPostMessage({ source: 'genetec', type: 'connection' });

export const usePowerAppsRefreshParent = () => {
  const { resetToken } = useAuth();

  const handleRefreshParentMessage = useCallback(
    (props: any) => {
      const data = postMessageConnection(props);
      if (!data) return;

      if (/refresh/.test(data?.event)) resetToken();
    },
    [resetToken],
  );

  usePostMessageListener(handleRefreshParentMessage);
};
